import React, { ChangeEvent, memo, useEffect, useState } from "react";
import { Box, FormControlLabel, Grid } from "@mui/material";
import { getIn, useFormikContext } from "formik";
import SectionContainer from "../../../../../common/SectionContainer";
import { includes } from "ramda";
import { InputAdornment } from "@mui/material";
import TextInput from "../../../../../common/formElements/TextInput";
import { Logo } from "../../../../../store/logo/types";
import {
  Data as TerminalType,
  Data,
} from "../../../../../store/terminal/types";
import ConfigurationOptions from "./ConfigurationOptions";
import ConfigurationQantas from "./ConfigurationQantas";
import ConfigurationTimeouts from "./ConfigurationTimeouts";
import ConfigurationStartup from "./ConfigurationStartup";
import ConfigurationOther from "./ConfigurationOther";
import ConfigurationMerchantChoice from "./ConfigurationMerchantChoice";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";
import OptionalToolTip from "../../../../../common/toolTip/OptionalToolTip";
import SectionWrapper from "../../../../../common/pageSections/SectionWrapper";
import CustomizedCheckbox from "./../../../../../common/formElements/Checkbox";
import CustomizedSwitch from "../../../../../common/formElements/Switch";
import { getValueForField } from "../editConfigurationComponent/ConfigurationOptions";
import useStyles from "../../../../pageStyles";
import { get } from "lodash";
import * as _ from "lodash";
import ConfigurationPreAuth from "./ConfigurationPreAuth";
import ConfigurationHotCard from "./ConfigurationHotCard";
import { fetchFieldAttributeConfig } from "../../../../../repo/configuration";

interface FormInput extends Data {
  _prepared?: boolean;
}

interface EditConfigurationProps {
  bulk: boolean;
  setShowBPGiftCardSupportMenu: (value: boolean) => void;
  setShowFixedAmountEntryMenu: (value: boolean) => void;
  setShowPayAtTableSection: (value: boolean) => void;
  setShowDRCMenu: (value: boolean) => void;
  setShowHTMLReceipts: (value: boolean) => void;
  initialValues: FormInput;
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

const options = [
  {
    label: "Standalone",
    field: "attributes.Standalone",
  },
  { label: "CloudPOS", field: "attributes.CloudPOS" },
  { label: "POSApp", field: "attributes.POSApp" },
  {
    label: "Cash Out",
    field: "attributes.FeatureCashOut",
  },
  {
    label: "No Cash Out In Debit",
    field: "attributes.NoCashOutInDebit",
  },
  {
    label: "Purchase with Cash Out",
    field: "attributes.FeaturePurWithCash",
  },
  {
    label: "Purchase with Tip",
    field: "attributes.FeaturePurWithTip",
  },
  {
    label: "Refund",
    field: "attributes.FeatureRefund",
  },
  {
    label: "Pre-Auth",
    field: "attributes.FeaturePreAuth",
  },
  {
    label: "Completion",
    field: "attributes.FeatureCompletion",
  },
  { label: "MOTO", field: "attributes.FeatureMOTO" },
  {
    label: "Manual Settlement",
    field: "attributes.FeatureManualSettlement",
  },
  {
    label: "Show Navigation",
    field: "attributes.ShowNavigation",
  },
  {
    label: "Show Last Settlement",
    field: "attributes.FeatureLastSettle",
  },
  {
    label: "Pre-Settlement",
    field: "attributes.FeaturePreSettle",
  },
  {
    label: "Welfare Restrictions",
    field: "attributes.WelfareRestriction",
  },
  {
    label: "Duplicate Transaction Check",
    field: "attributes.DuplicateTxnCheck",
  },
  {
    label: "Idle On Amount Entry",
    field: "attributes.IdleOnAmountEntry",
  },
  {
    label: "BP Card Support",
    field: "attributes.BpCardSupport",
  },
  {
    label: "BP Gift Card Support",
    field: "attributes.FeatureBPGiftCards",
  },
  {
    label: "Terminal Status Reporting",
    field: "attributes.TerminalStatusReportingEnabled",
  },
  {
    label: "Terminal GPS",
    field: "attributes.TerminalGPSEnabled",
  },
  {
    label: "Network Connection Manager",
    field: "attributes.NetworkConnectionManagerEnabled",
  },
  {
    label: "Qantas Loyalty Enabled",
    field: "attributes.FeatureQantasLoyaltyEnabled",
  },
  {
    label: "Qantas Loyalty Cash Password Protect",
    field: "attributes.FeatureQantasLoyaltyCashPasswordProtect",
  },
  {
    label: "Partial Payment",
    field: "attributes.FeaturePartialPaymentEnabled",
  },
  {
    label: "MentorLite",
    field: "attributes.FeatureMentorLite",
  },
  {
    label: "Lite Theme Enabled",
    field: "attributes.FeatureLiteThemeEnabled",
  },
  {
    label: "Crypto.com Enabled",
    field: "attributes.FeatureCryptoDotComEnabled",
  },
  {
    label: "Crypto.com Refunds From Terminal Allowed",
    field: "attributes.FeatureCryptoDotComRefundsEnabled",
  },
  {
    label: "Use Fixed Payments UI",
    field: "attributes.FeatureFixedAmountEntryEnabled",
  },
  {
    label: "Pay at Table Enabled",
    field: "attributes.PayAtTableEnabled",
  },
  {
    label: "Enable Dining Rewards Club",
    field: "attributes.FeatureDRCLoyaltyEnabled",
  },
  {
    label: "Key Entry Password",
    field: "attributes.KeyEntryPromptPassword",
  },
  {
    label: "MOTO Password",
    field: "attributes.MOTOPromptPassword",
  },
  {
    label: "Allow Basket Data to Terminal",
    field: "attributes.AllowBasketData",
  },
  {
    label: "Taxi Mode Enabled",
    field: "attributes.FeatureA2BTaxiModeEnabled",
  },
  {
    label: "Fastcard Enabled",
    field: "attributes.FeatureCabchargeFastCardEnabled",
  },
  {
    label: "Enable Self-Installation",
    field: "attributes.EnableSelfInstall",
  },
  {
    label: "Enable Cash Out Limit",
    field: "attributes.FeatureCashOutLimitEnabled",
  },
  {
    label: "Stationery Order",
    field: "attributes.EnableStationeryOrder",
  },
  {
    label: "Fleet Card via Fiserv",
    field: "attributes.FeatureFleetCardAuthCompletion",
  },
  {
    label: "Feature Pair With POS Enabled",
    field: "attributes.FeaturePairWithPOSEnabled",
  },
  {
    label: "Show Back Button On Present Card Screen",
    field: "attributes.ShowBackButtonOnPresentCardScreen",
  },
  {
    label: "Show Cancel Button On Present Card Screen",
    field: "attributes.ShowCancelButtonOnPresentCardScreen",
  },
  {
    label: "Feature Updater Enable",
    field: "attributes.FeatureUpdaterEnable",
  },
  {
    label: "Fusion API Logging",
    field: "attributes.FeatureFusionAPILoggingEnabled",
  },
  {
    label: "Reversal Managed On Host",
    field: "attributes.ReversalManagedOnHost",
  },
  {
    label: "Pay On Other Terminal",
    field: "attributes.PayOnOtherTerminal",
  },
  {
    label: "Enable Split Payments",
    field: "attributes.EnableSplitPayments",
  },
  {
    label: "Show Status Bar",
    field: "attributes.ShowStatusBar",
  },
  {
    label: "USB POS",
    field: "attributes.USBPOS",
  },
  {
    label: "Is HotCardDelta Download Allowed",
    field: "attributes.IsHotcardDeltaDownloadAllowed",
  },
  {
    label: "Hashed HotCard Enabled",
    field: "attributes.HashedHotCardEnabled",
  },
  {
    label: "Enable Feature Shell Contactless",
    field: "attributes.FeatureShellContactless",
  },
  {
    label: "Enable Feature PreAuth And Completion",
    field: "attributes.FeaturePurchaseWithPreAuthAndCompletion",
  },
];

/**
 * Find Logo in logos array
 *
 * Return filename if logo is found
 * Return "" if field is null
 * Return "DMG_Default.png" is logo is not found
 *  "DMG_Default.png" is set as default logo
 *   in case the logo set on terminal is not found
 *
 * @param {string} field
 * @param {Logo[]} existingLogos
 * @return {string}
 */
const findLogoByFileName = (field: string, existingLogos: Logo[]) => {
  return !field
    ? ""
    : existingLogos.find((x) => x.FileName == field)
    ? field
    : "DMG_Default.png";
};

function EditConfgurationComponent({
  bulk,
  setShowBPGiftCardSupportMenu,
  setShowFixedAmountEntryMenu,
  setShowPayAtTableSection,
  setShowDRCMenu,
  setShowHTMLReceipts,
  initialValues,
  isUpdateAllowed,
  shouldHideField,
}: EditConfigurationProps) {
  const formikProps = useFormikContext();
  const values = formikProps.values as unknown as Data;
  const { setFieldValue } = formikProps;
  const classes = useStyles();

  // State for field attribute configuration
  const [fieldAttributeConfig, setFieldAttributeConfig] = useState<string[] | null>(null);
  const [filteredOptions, setFilteredOptions] = useState(options);

  const paymentMethods = [
    "Manual",
    "Contactless",
    "Contact",
    "Magnetic",
    "QRCode",
  ];

  //Fetch field attribute configuration from backend
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const fieldAttributes = await fetchFieldAttributeConfig();
        setFieldAttributeConfig(fieldAttributes.data);
        
        // Filter options based on the configuration
        if (fieldAttributes.data && fieldAttributes.data.length > 0) {
          const filtered = options.filter(option => 
            fieldAttributes.data.includes(option.field)
          );
          setFilteredOptions(filtered);
        } else {
          // If field attributes array is empty, show all options
          setFilteredOptions(options);
        }
      } catch (error) {
        console.error("Failed to fetch field attribute configuration:", error);
        // Fallback to all options if fetch fails
        setFilteredOptions(options);
      }
    };

    fetchConfig();
  }, []);

  const checkedTransitMode =
    values &&
    values.attributes &&
    get(values, "attributes.TransitMode") === "Yes";

  const [checkedPreAuth, setCheckedPreAuth] = useState(
    values &&
      values.attributes &&
      get(values, "attributes.FeaturePreAuth") === "Yes"
  );
  const checkedDisableLogin =
    values &&
    values.attributes &&
    get(values, "attributes.DisableLogin") === "Yes";

  const enableHotCard = Boolean(
      values &&
      values.attributes &&
      get(values, "attributes.HashedHotCardEnabled") === "Yes"
  );

  const terminalBackgrounds = useSelector((state: ApplicationState) => Array.isArray(state.terminalBackground.data) ? state.terminalBackground.data : []);
  useEffect(() => {
    if (
      values.attributes.IdleBitmap &&
      Array.isArray(terminalBackgrounds) &&
      terminalBackgrounds.length > 0
    ) {
      const found = terminalBackgrounds.find(
        (x) => x.attributes.FileName === values.attributes.IdleBitmap
      );
      if (!found) {
        setFieldValue("attributes.IdleBitmap", "DMG_Default.png");
      }
      // else, do nothing, keep the DB value
    }
    // Only run when terminalBackgrounds is loaded
  }, [terminalBackgrounds]);

  const handleOnChangeCheckbox = (
    e: ChangeEvent<HTMLInputElement>,
    meth: string
  ) => {
    const currentMethods = getIn(values, `attributes.PaymentMethods`);
    if (e.currentTarget.checked) {
      setFieldValue(
        `attributes.PaymentMethods`,
        currentMethods !== undefined ? [...currentMethods, meth] : [meth]
      );
    } else {
      setFieldValue(
        `attributes.PaymentMethods`,
        currentMethods.filter(
          (x: string) => x.toLowerCase() !== meth.toLowerCase()
        )
      );
    }
  };

  const isDisableKeyEntryPassword = () => {
    let checkedValue = false;
    paymentMethods.map((meth) => {
      if (meth === "Manual")
        checkedValue = values.attributes?.PaymentMethods
          ? includes(meth, values.attributes.PaymentMethods)
          : false;
    });
    return !checkedValue;
  };
  const isQT850Terminal = () => values.attributes.TerminalType === "QT 850";
  const isQuestTerminal = () =>
    values &&
    values.attributes &&
    values.attributes.Manufacturer &&
    values.attributes.Manufacturer.toUpperCase() === "QUEST";
  const isNotQT850Terminal = () => !isQT850Terminal();
  const hiddenOptionFields = [];
  if (isQT850Terminal()) {
    hiddenOptionFields.push("attributes.FeaturePreAuth");
  }
  if (isQuestTerminal()) {
    hiddenOptionFields.push("attributes.FeatureUpdaterEnable");
  }
  if (isQuestTerminal()) {
    hiddenOptionFields.push("attributes.EnableSplitPayments");
  }
  return (
    <SectionContainer
      heading="Configuration"
      name="sections.configuration"
      bulk={bulk}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SectionWrapper isChild title="Options">
            <Box p={2} pt={0}>
              <ConfigurationOptions
                setShowBPGiftCardSupportMenu={setShowBPGiftCardSupportMenu}
                setShowFixedAmountEntryMenu={setShowFixedAmountEntryMenu}
                setShowPayAtTableSection={setShowPayAtTableSection}
                setShowDRCMenu={setShowDRCMenu}
                setShowHTMLReceipts={setShowHTMLReceipts}
                options={filteredOptions}
                hiddenFields={hiddenOptionFields}
                isUpdateAllowed={isUpdateAllowed}
                isDisableKeyEntryPassword={isDisableKeyEntryPassword()}
                shouldHideField={shouldHideField}
              />
            </Box>
          </SectionWrapper>
        </Grid>

        <Grid item xs={12}>
          <SectionWrapper isChild title="Payment Methods">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {paymentMethods?.map((meth: string) => {
                  return (
                    <FormControlLabel
                      key={meth}
                      control={
                        <CustomizedCheckbox
                          checked={
                            values.attributes?.PaymentMethods
                              ? includes(meth, values.attributes.PaymentMethods)
                              : false
                          }
                          onChange={(e) => handleOnChangeCheckbox(e, meth)}
                          name="attributes.PaymentMethods"
                          disabled={!isUpdateAllowed}
                        />
                      }
                      label={meth}
                    />
                  );
                })}
              </Grid>
            </Grid>
          </SectionWrapper>
        </Grid>
        {isQT850Terminal() && !shouldHideField("attributes.FeaturePreAuth") && (
          <Grid item xs={12}>
            <SectionWrapper isChild title="Pre Auth Settings">
              <Grid container className={classes.paddingLeft} spacing={3}>
                <Grid item xs={12} md={4}>
                  <FormControlLabel
                    label={
                      <OptionalToolTip
                        tooltip={
                          "When enabled, the Pre-Auth transaction option is available in the terminal options menu"
                        }
                      >
                        Pre Auth
                      </OptionalToolTip>
                    }
                    control={
                      <CustomizedSwitch
                        name={"attributes.FeaturePreAuth"}
                        checked={checkedPreAuth}
                        onChange={(event, value) => {
                          setFieldValue(
                            "attributes.FeaturePreAuth",
                            getValueForField("attributes.FeaturePreAuth", value)
                          );
                          setCheckedPreAuth(value);
                        }}
                        disabled={!isUpdateAllowed}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <ConfigurationPreAuth
                    labelTooltip="Pre Auth"
                    isUpdateAllowed={isUpdateAllowed}
                    checkedPreAuth={checkedPreAuth}
                    PreAuth={values.attributes.PreAuth}
                    onPreAuthValueChanged={(PreAuthValue) => {
                      setFieldValue("attributes.PreAuth", PreAuthValue);
                    }}
                    shouldHideField={shouldHideField}
                  />
                </Grid>
              </Grid>
            </SectionWrapper>
          </Grid>
        )}
        {!shouldHideField("attributes.TransitMode") && (
          <Grid item xs={12}>
            <SectionWrapper isChild title="Transit Methods">
              <Grid container className={classes.paddingLeft} spacing={2}>
                <Grid item xs={12} md={4}>
                  <FormControlLabel
                    label={
                      <OptionalToolTip tooltip={"Enable Offline Transit Mode"}>
                        Transit Mode
                      </OptionalToolTip>
                    }
                    control={
                      <CustomizedSwitch
                        name={"attributes.TransitMode"}
                        checked={checkedTransitMode}
                        onChange={(event, value) => {
                          setFieldValue(
                            "attributes.TransitMode",
                            getValueForField("attributes.TransitMode", value)
                          );
                        }}
                        disabled={!isUpdateAllowed}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControlLabel
                    label={
                      <OptionalToolTip tooltip={"Disable terminal Login to host"}>
                        Disable Login
                      </OptionalToolTip>
                    }
                    control={
                      <CustomizedSwitch
                        name={"attributes.DisableLogin"}
                        checked={checkedDisableLogin}
                        onChange={(event, value) => {
                          setFieldValue(
                            "attributes.DisableLogin",
                            getValueForField("attributes.DisableLogin", value)
                          );
                        }}
                        disabled={!isUpdateAllowed}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <OptionalToolTip tooltip="Set Blocked List Refresh Intervals">
                    <TextInput
                      key={`attributes.TransitBlockListRefreshIntervalMs`}
                      fieldname="attributes.TransitBlockListRefreshIntervalMs"
                      label="Configure Block List Refresh Intervals (in minutes)"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">minutes</InputAdornment>
                        ),
                      }}
                    />
                  </OptionalToolTip>
                </Grid>
              </Grid>
            </SectionWrapper>
          </Grid>
        )}

        {!shouldHideField("attributes.FeatureQantasLoyaltyEnabled") && (
          <Grid item xs={12}>
            <SectionWrapper isChild title="Qantas">
              <ConfigurationQantas
                options={[
                  {
                    label: "Qantas Loyalty Password (numbers, max 4 digits)",
                    field: "attributes.FeatureQantasLoyaltyCashPassword",
                    labelTooltip: "Qantas Loyalty Password",
                    onInput: (e) => {
                      const target = e.target as HTMLInputElement;
                      target.value = target.value.replace(/[^0-9]/g, "");
                      if (target.value.length > 4) {
                        target.value = target.value.substring(0, 4);
                      }
                    },
                  },
                  {
                    label: "Qantas Loyalty Logo URL",
                    field: "attributes.QantasLoyaltyLogoUrl",
                    labelTooltip: "Qantas Loyalty Logo URL",
                    onInput: (e) => {
                      const target = e.target as HTMLInputElement;
                      if (target.value.length > 2048) {
                        target.value = target.value.substring(0, 2048);
                      }
                    },
                  },
                ]}
                values={values}
                isUpdateAllowed={isUpdateAllowed}
                shouldHideField={shouldHideField}
              />
            </SectionWrapper>
          </Grid>
        )}
        <Grid item xs={12}>
          <SectionWrapper isChild title="Timeouts">
            <ConfigurationTimeouts
              options={[
                {
                  label: "CloudPOS timeout (sec)",
                  field: "attributes.CloudPosTimeout",
                  labelTooltip: "Cloudpos Timeout",
                  onInput: (e) => {
                    const target = e.target as HTMLInputElement;
                    target.value = target.value.replace(/[^0-9]/g, "");
                  },
                },
                {
                  label: "Inactivity timeout (sec)",
                  field: "attributes.InactivityTimeout",
                  labelTooltip: "Inactivity Timeout",
                  onInput: (e) => {
                    const target = e.target as HTMLInputElement;
                    target.value = target.value.replace(/[^0-9]/g, "");
                  },
                },
                {
                  label: "Result timeout (ms)",
                  field: "attributes.ResultTimeout",
                  labelTooltip: "Result Timeout",
                  onInput: (e) => {
                    const target = e.target as HTMLInputElement;
                    target.value = target.value.replace(/[^0-9]/g, "");
                  },
                },
                {
                  label: "Signature Timeout",
                  field: "attributes.SignatureTimeOut",
                  labelTooltip: "Signature Timeout",
                  selects: [
                    { value: "Approve", display: "Approve" },
                    { value: "Decline", display: "Decline" },
                  ],
                },
                {
                  label: "Fallback retry count",
                  field: "attributes.FallbackRetryCount",
                  labelTooltip: "Fallback Retry Count",
                },
                {
                  label: "Terminal Status update interval (sec)",
                  field: "attributes.TerminalStatusReportingIntervalSeconds",
                  labelTooltip: "Terminal Status Update Interval",
                  onInput: (e) => {
                    const target = e.target as HTMLInputElement;
                    target.value = target.value.replace(/[^0-9]/g, "");
                  },
                },
                {
                  label: "Crypto.com Refund Availability Window (seconds)",
                  field: "attributes.WindowForCDCRefundOptionSeconds",
                  labelTooltip: "Crypto.com Refund Window",
                  onInput: (e) => {
                    const target = e.target as HTMLInputElement;
                    target.value = target.value.replace(/[^0-9]/g, "");
                  },
                },
                {
                  label: "GPS Location update interval (sec)",
                  field: "attributes.TerminalGPSUpdateIntervalSeconds",
                  labelTooltip: "GPS Location Update Interval",
                  onInput: (e) => {
                    const target = e.target as HTMLInputElement;
                    target.value = target.value.replace(/[^0-9]/g, "");
                  },
                },
                {
                  label: "Screen Dimming Timeout (Ms)",
                  field: "attributes.ScreenDimmingTimeoutMs",
                  labelTooltip: "Screen Dimming Timeout",
                  onInput: (e) => {
                    const target = e.target as HTMLInputElement;
                    target.value = target.value.replace(/[^0-9]/g, "");
                  },
                },
              ]}
              isUpdateAllowed={isUpdateAllowed}
              shouldHideField={shouldHideField}
            />
          </SectionWrapper>
        </Grid>

        {!shouldHideField("attributes.StartupMode") && (
          <Grid item xs={12}>
            <SectionWrapper isChild title="Startup Mode">
              <ConfigurationStartup
                labelTooltip="Startup Mode"
                isUpdateAllowed={isUpdateAllowed}
                shouldHideField={shouldHideField}
              />
            </SectionWrapper>
          </Grid>
        )}

        {!shouldHideField("attributes.FeatureMCR") && (
          <Grid item xs={12}>
            <SectionWrapper isChild title="Merchant Choice Routing (MCR)">
              <ConfigurationMerchantChoice 
                isUpdateAllowed={isUpdateAllowed} 
                shouldHideField={shouldHideField}
              />
            </SectionWrapper>
          </Grid>
        )}
        {enableHotCard && !shouldHideField("attributes.HashedHotCardEnabled") && (
            <Grid item xs={12}>
              <SectionWrapper isChild title="HotCard">
                <ConfigurationHotCard
                    labelTooltip="HotCard"
                    isUpdateAllowed={isUpdateAllowed}
                    shouldHideField={shouldHideField}
                />
              </SectionWrapper>
            </Grid>
        )}
        {!shouldHideField("attributes.FeatureOthers") && (
          <Grid item xs={12}>
            <SectionWrapper isChild title="Others">
              <ConfigurationOther
                isUpdateAllowed={isUpdateAllowed}
                initialValues={initialValues}
                shouldHideField={shouldHideField}
              />
            </SectionWrapper>
          </Grid>
        )}
      </Grid>
    </SectionContainer>
  );
}
export default memo(EditConfgurationComponent);
